import { createRoute } from "@tanstack/react-router";
import { SettingsPage } from "@/components/settings-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/settings",
  component: SettingsPage,
});
